import type { SVGProps } from "react";
// generated from CloudUpdate.svg — do not edit manually
// prettier-ignore
export default function CloudUpdate(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M16 15L12 19M12 19L8 15M12 19V2M10 8.341C8.28 8.95 6.921 10.32 6.326 12.046C3.883 12.375 2 14.467 2 17C2 19.761 4.239 22 7 22H17C19.761 22 22 19.761 22 17C22 14.467 20.116 12.375 17.673 12.046C17.078 10.32 15.719 8.95 14 8.341" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
